import src from "IMAGE";
export default { src, width: 211, height: 44, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAsEAgsKBAIKDQUCDVciD1FWIQ9QDwYDDgsEAgsLBAIMABoKBRsXCQQZIAwGIIw2GImGNBeDFAgDFBoKBBsaCgUcvekGq5zEkksAAAAASUVORK5CYII="};
